import { readProps } from './objects'
import { toDate, toPrice, toTextarea } from '@/utils/filters'
import clsx from 'clsx'

const patterns = [
  {
    pattern: /{(.+?)}/gi,
    replacer: (val, data, errValue) => (readProps(val, data, errValue))
  }
]

export const replaceContent = (content, data, errValue) => {
  content = String(content)
  patterns.forEach(({ pattern, replacer }) => {
    content = content.replace(pattern, (match, g1) => {
      let value = replacer(g1, data, errValue)
      return value
    })
  })
  return content
}
export const createList = (list, content) => {
  let listLi = []
  list.forEach((item) => {
    let li = `<li>${replaceContent(content, item)}</li>`
    listLi.push(li)
  })
  return listLi.length ? `<ul>${listLi.join('')}</ul>` : ''
}
export const createLink = (href, title) => {
  return href ? `<a href="${href}">${title}</a>` : null
}

const replaceTemplate = (value, replacer) => {
  return String(value).replace(
    /{{(.|\n)+?}}/g, (v) => {
      const key = v.substring(2, v.length - 2)
      return replacer(key)
    }
  )
}

const defaultOnEmpty = () => '--'
const defaultOnError = (key, error) => {
  console.error(error)
  return ''
}

export const calcHtmlTemplate = (value, payload = {}, options = {}) => {
  payload = { toDate, toPrice, clsx, toTextarea, ...payload }
  const config = Object.entries(payload).map(([argName, param]) => ({ argName, param }))
  const { onEmpty = defaultOnEmpty, onError = defaultOnError } = options

  const argsString = config.map(({ argName }) => argName).join(',')
  const params = config.map(({ param }) => param)

  return replaceTemplate(value, (key) => {
    try {
      // eslint-disable-next-line
      const fun = new Function(argsString, `return ${key}`)
      const result = fun(...params)
      return [null, undefined].some((v) => v === result) ? onEmpty(key) : result
    } catch (e) {
      const isDev = process.env.NODE_ENV === 'development'
      isDev && console.error(key)
      return onError(key, e)
    }
  })
}
